module.exports = __webpack_public_path__ + "static/img/feature_1.2c130d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/feature_1.png
// module id = Z1X0
// module chunks = 0